import React from "react";
import { Drawer as AntDrawer } from "antd";
import "./index.scss";

const Drawer: React.FC<any> = ({ ...props }: any) => {
   return <AntDrawer {...props} />;
};

export default Drawer;
